import { useEffect, useState } from "react";
import { Loader, toaster } from "rsuite";
import CardC from "../../../components/CustomCard/CardC";
import peticionBack from "../../../libs/peticiones/peticionBack";
import Datatable from "../../../components/Datatable/Datatable";
import createURL from "../../../libs/peticiones/url";
import { System } from "../../../types/admin-usuarios/System";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-regular-svg-icons";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { swalAction } from "../../../components/Modals/ModalConfirm";
import { Button } from "react-bootstrap";
import Form from "./Form";
import { useStore } from "../../../context/AppContext";
import { checkPermission } from "../../../libs/menuPermissions/permissions";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export default function Sistemas() {
    const [loading, setLoading] = useState<boolean>(false);
    const [refresh, setRefresh] = useState<boolean>(false);
    const [open, setOpen] = useState<boolean>(false);
    const [selected, setSelected] = useState<System | undefined>();
    const { state } = useStore();

    async function getData(
        order: string,
        records: number,
        page: number,
        search: string
    ) {
        const url = createURL("/sistemas", [
            { name: "order", value: order },
            { name: "records", value: records },
            { name: "page", value: page },
            { name: "search", value: search },
            { name: "rows", value: "_id,name,description" },
        ]);
        const res = await peticionBack({}, url, "GET", false, toaster);
        return res;
    }

    useEffect(() => { 
        if(!open){
           setSelected (undefined)
        }

    }, [open]);

    function openToEdit(row: System) {
        setSelected(row);
        setOpen(true);
    }

    async function deleteRow(id: string) {
        setLoading(true);
        const res = await peticionBack({}, `/sistemas/${id}`, "DELETE", true, toaster);
        if (res) setRefresh(true);
        setLoading(false);
    }

    /* TABLA */
    const columns = [
        { data: "name", orderValue: "name" },
        { data: "description", orderValue: "description" },
        {
            data: null,
            render: (row: System) => (
                <div className="d-flex justify-content-evenly">
                   {checkPermission(state, "update") && <FontAwesomeIcon icon={faPencil as IconProp} className="text-warning cursor-pointer" onClick={() => openToEdit(row)}/>}
                   {checkPermission(state, "delete") &&  <FontAwesomeIcon
                        icon={faTrashCan as IconProp}
                        className="text-danger cursor-pointer"
                        onClick={() =>
                            swalAction(
                                deleteRow,
                                "Eliminar sistema",
                                `¿Desea eliminar el sistema ${row.name}?`,
                                "question",
                                row._id,
                                "Eliminar"
                            )
                        }
                    />}
                </div>
            ),
        },
    ];

    const headers = ["Nombre","Descripción", "Acciones"];
    const columnsDef = [
        { orderable: false, targets: [2] },
        { className: "text-center", targets: [0] },
    ];

    return (
        
        <CardC>
            <div className="d-flex flex-column flex-md-row justify-content-md-between mb-2">
                <h4>Sistemas</h4>
                {!open && checkPermission(state, "create") && (
                    <Button onClick={() => setOpen(true)} className="my-1 my-md-0">
                        Agregar
                    </Button>
                )}
            </div>
            {open ? (
                <Form setOpen={setOpen} selected={selected} />
            ) : checkPermission(state, "read") && (
                <Datatable
                    columns={columns}
                    columnDefs={columnsDef}
                    headers={headers}
                    control="back"
                    petition={getData}
                    stateRefresh={[refresh, setRefresh]}
                />
            )}
            {loading && <Loader backdrop vertical style={{ zIndex: 5 }} />}
        </CardC>
    );
}
